import styled from 'styled-components'

export const Container = styled.p`
  text-align: center;
  font-size: 14px;
  line-height: 140%;
  margin: 0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  padding: ${({ theme }) => theme.tokens.spacingUnit * 2}px;
  border-radius: ${({ theme }) => theme.tokens.spacingUnit}px;
  background: ${({ theme }) => theme.colors.neutral.black100};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`
